import React, { useState, useEffect } from 'react';
import { Steps, Card, Button, message, Spin, Result } from 'antd';
import { CheckCircleOutlined, UserOutlined, MedicineBoxOutlined, HeartOutlined } from '@ant-design/icons';
import api from '../api';

const { Step } = Steps;

const PatientIntakePortalPageSimple = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [sessionId, setSessionId] = useState(null);
  const [mrn, setMrn] = useState(null);
  const [loading, setLoading] = useState(false);

  // Initialize intake session on component mount
  useEffect(() => {
    initializeIntakeSession();
  }, []);

  const initializeIntakeSession = async () => {
    setLoading(true);
    try {
      const response = await api.post('/intake/start');
      if (response.data.status === 'success') {
        setSessionId(response.data.data.sessionId);
        setMrn(response.data.data.mrn);
        message.success('Intake session started successfully');
      }
    } catch (error) {
      console.error('Error starting intake session:', error);
      message.error('Failed to start intake session. Please refresh the page and try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh' 
      }}>
        <Spin size="large" />
        <p style={{ marginTop: 20 }}>Initializing your intake session...</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: 20 }}>
      <div style={{ textAlign: 'center', marginBottom: 30 }}>
        <h1 style={{ color: '#1890ff', fontSize: '2.5rem' }}>Patient Intake Portal</h1>
        <p style={{ fontSize: '1.1rem' }}>Welcome to Care360. Please complete all sections to create your patient record.</p>
        {mrn && (
          <div style={{ 
            marginTop: 15, 
            padding: '10px 20px', 
            backgroundColor: '#e6f7ff', 
            border: '1px solid #91d5ff', 
            borderRadius: 6 
          }}>
            <strong>Your Reference Number: {mrn}</strong>
          </div>
        )}
      </div>

      <Card style={{ marginBottom: 30 }}>
        <Steps current={currentStep}>
          <Step
            title="Demographics"
            description="Personal Information"
            icon={<UserOutlined />}
          />
          <Step
            title="Medical History"
            description="Health Background"
            icon={<MedicineBoxOutlined />}
          />
          <Step
            title="Lifestyle"
            description="Lifestyle Questionnaires"
            icon={<HeartOutlined />}
          />
        </Steps>
      </Card>

      <Card style={{ minHeight: 400 }}>
        <div style={{ padding: 20, textAlign: 'center' }}>
          <h3>Step {currentStep + 1}: {['Demographics', 'Medical History', 'Lifestyle'][currentStep]}</h3>
          <p>This is a simplified test version of the intake portal.</p>
          <p>Session ID: {sessionId}</p>
          <p>MRN: {mrn}</p>
          
          <div style={{ marginTop: 30 }}>
            {currentStep > 0 && (
              <Button 
                style={{ marginRight: 16 }} 
                onClick={() => setCurrentStep(currentStep - 1)}
              >
                Previous
              </Button>
            )}
            {currentStep < 2 ? (
              <Button 
                type="primary" 
                onClick={() => setCurrentStep(currentStep + 1)}
              >
                Next
              </Button>
            ) : (
              <Button 
                type="primary" 
                onClick={() => message.success('Intake would be submitted here')}
              >
                Submit Intake
              </Button>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PatientIntakePortalPageSimple;
